import script from "./changePassword.vue?vue&type=script&lang=ts&setup=true"
export * from "./changePassword.vue?vue&type=script&lang=ts&setup=true"

import "./changePassword.vue?vue&type=style&index=0&id=a2197176&scoped=true&lang=css"

import exportComponent from "E:\\phpstudy_pro\\WebWWW\\client-dev\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2197176"]])

export default __exports__